import { Col } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { IFullscreenAttachment } from 'components/domain/attachment/AttachmentFullscreenViewer/AttachmentFullscreenViewer';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { ErrorState, LoadingState } from '../../../../components';
import './PhotoFullscreen.scss';

export interface IPhotoFullScreenProps {
  photo?: IFullscreenAttachment;
  performShake: boolean;
  showAnnotations?: boolean;
  annotationFileUrl?: string;
}

const PhotoFullScreen: React.FunctionComponent<IPhotoFullScreenProps> = (props) => {
  const { photo, performShake, showAnnotations, annotationFileUrl } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<boolean>(false);
  const classes = classNames('photo-full-screen', 'image-container', {
    'ac-shake': performShake,
  });

  const imageSource = showAnnotations && annotationFileUrl ? annotationFileUrl : photo?.fileUrl;

  const imgRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    if (!imageSource) {
      setIsLoading(false);
      setError(false);
      return;
    }

    setIsLoading(true);
    setError(false);

    const img = imgRef.current;
    if (img && img.complete && img.naturalWidth > 0) {
      setIsLoading(false);
    }
  }, [imageSource]);

  function handleImageFinishedLoading() {
    setIsLoading(false);
  }

  function handleImageErrorLoading() {
    setIsLoading(false);
    setError(true);
  }

  return (
    <Col className={classes}>
      <div className="image">
        {photo && imageSource && (
          <img
            key={imageSource}
            src={imageSource}
            onLoad={handleImageFinishedLoading}
            onError={handleImageErrorLoading}
            alt=""
            ref={imgRef}
          />
        )}
      </div>
      {isLoading && !error ? <LoadingState /> : null}
      {error && <ErrorState />}
    </Col>
  );
};

export default PhotoFullScreen;
